import {throttle} from "./throttle";

export function globalAnimation() {
  let
    win = $(window),
    videoBlocksSelector = '.media-block video',
    imageBlocksSelector = '.image:not(.init)',
    //animatedBlocksSelector = ".head .line, .post-info .line, .information-left .line, .frontier-section-top .line, .frontier .line",
    animatedBlocksSelector = ".line",
    videoBlocks = $(videoBlocksSelector),
    imageBlocks = $(imageBlocksSelector),
    animatedBlocks = $(animatedBlocksSelector);

  function initAnimatedBlocks(obj) {
    obj.each(function () {
      let cur = $(this);

      if (!cur.hasClass("animated")) {
        let
          offset = parseInt(cur.offset().top),
          wTop = win.scrollTop(),
          h = parseInt(offset + cur.outerHeight());

        if ((h < wTop) || (offset > (wTop + win.height()))) {

        } else {
          cur.addClass("animated");
        }
      }

    });
  }

  function initVideo(obj) {
    obj.each(function () {
      let
        cur = $(this),
        offset = parseInt(cur.offset().top),
        wTop = win.scrollTop(),
        h = parseInt(offset + cur.outerHeight());

      if ((h < wTop) || (offset > (wTop + win.height()))) {
        cur[0].pause();
      } else if (cur.hasClass("visible")) {
        cur[0].play();
      } else {
        cur[0].pause();
      }
    });
  }

  function loadImageBlocks(obj) {
    if (obj.length) {
      obj.each(function () {
        let cur = $(this);

        if (!cur.hasClass('init')) {
          let
            offset = parseInt(cur.offset().top),
            wTop = win.scrollTop(),
            h = parseInt(offset + cur.outerHeight());

          if ((h < wTop) || (offset > (wTop + win.height()))) {

          } else {
            cur.addClass("init");

            let
              newImg = new Image(),
              src = cur.data('src');

            newImg.onload = function () {
              cur.addClass("loaded");
              cur.find('img').attr('src', src);
              cur.find('>div').css('background-image', `url("${src}")`);
            };

            newImg.src = src;
          }
        }

      });
    }
  }

  win.on("load", function () {
    loadImageBlocks(imageBlocks);

    setTimeout(function () {

      initVideo(videoBlocks);
      initAnimatedBlocks(animatedBlocks);

      $('body').addClass('page-loaded');
    }, 1000);

  })/*.on("orientationchange", function () {

  }).on("resize", throttle(function () {

  }, 150))*/.on("scroll.globalAnimation", throttle(function () {
    initVideo(videoBlocks);
    loadImageBlocks(imageBlocks);
    initAnimatedBlocks(animatedBlocks);

  }, 50)).on("changeAnimatedBlocks", function () {
    animatedBlocks = $(animatedBlocksSelector);
    initAnimatedBlocks(animatedBlocks);

  }).on("changeImageBlocks", function () {
    imageBlocks = $(imageBlocksSelector);
    loadImageBlocks(imageBlocks);

  }).on("changeVideoBlocks", function () {
    initVideo(videoBlocks);
  });

  return {
    initVideo() {
      initVideo(videoBlocks);
    }
  };
}


// WEBPACK FOOTER //
// ./assets/js/modules/globalAnimation.js